import { ACTIVE_CAMPAIGN_SETTINGS_API } from 'modules/profile/integrations/active-campaign-integration/api/active-campaign-settings-api'
import { ActiveCampaignSettingsInterface } from 'modules/profile/integrations/active-campaign-integration/types/active-campaign-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useActiveCampaignSettings() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, ActiveCampaignSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: activeCampaignData, mutate } = useSWR(() => {
    if (user) {
      return ACTIVE_CAMPAIGN_SETTINGS_API
    }
    return null
  }, fetcher)
  return { activeCampaignData, mutate }
}
